<template>
    <div>
        <div class="options d-flex align-items-center m-3 justify-content-between">
            <div class="d-flex col-sm-3 pl-0">
                <div class="d-flex w-100">
                    <input class="glued-right bg-lighter w-100" type="text" v-model="searchQuery" placeholder="Search">
                    <div class="glued-left dark"><i class="ico-search larger color-1"></i></div>
                </div>
            </div>

            <button class="btn" @click="addProduct">
                <i class="ico ico-add"></i> Add Product
            </button>
        </div>
        <!-- <div class="options d-flex align-items-center m-3">
            <search table="products"></search>
            <export></export>
        </div> -->

        <div v-if="getLoadingProducts" class="p-4 text-center">
            <loader></loader>
        </div>
        <div v-else>
            <list :header="header" :body="body" :rows="filteredResults" :actions="actions"></list>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import List from '@/tools/list/baseList'
    import Search from '@/tools/Search'
    import Export from '@/tools/Export'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function() {
            return {
                searchQuery: null,
                loading: false,
                body: {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        name: this.formatName,
                        // active: this.formatStatus,
                        category: this.formatCategory,
                        // duration: this.formatDurationRange,
                        // capacity: this.formatCapacity,
                        active: this.formatActive
                    },
                    customRowEvent: this.view,
                },
                actions: {
                    label : 'Actions',
                    list: [
                        {
                            slug: 'duplicate',
                            title: 'Duplicate',
                            tooltip: 'Duplicate',
                            params: '',
                            class: '',
                            icon: 'fas fa-clone largest',
                            event: this.duplicateProduct,
                        },
                        {
                            slug: 'edit',
                            title: 'Edit',
                            tooltip: 'Edit',
                            params: '',
                            class: '',
                            icon: 'ico-edit largest',
                            event: this.view,
                        },
                        {
                            slug: 'delete',
                            title: 'Delete',
                            tooltip: 'Delete',
                            params: '',
                            class: '',
                            icon: 'ico-delete largest',
                            event: this.remove,
                        }
                    ],
                },
            }
        },
        computed: {
            ...mapGetters([
                'getProducts',
                'getProductsLabels',
                'account',
                'getLoadingProducts'
            ]),
            header: function() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: this.getProductsLabels,
                };
            },
            filteredResults: function() {
                //just to sort alfabetically
                function compare(a,b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase())
                        return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase())
                        return 1;
                    return 0;
                }


                let output = null
                if(this.searchQuery){
                    output = this.getProducts.filter(product => {
                        return product.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                    })
                } else {
                    output = this.getProducts
                }

                return output.sort(compare);
            }
        },
        created: function(){
            // this.initProducts()
        },
        methods: {
            ...mapActions([
                'setSelectedItem',
                'addItem',
                'removeItem',
                'flushEvents',
                'initProducts',
                'openModal'
            ]),
            duplicateProduct: function (item) {
                if (item.id !== undefined) {
                    this.setSelectedItem({ table: 'products', id: item.id });
                    this.openModal('ProductDuplicate')
                }
            },
            view: function(item) {
                if (item.id !== undefined) {
                    this.setSelectedItem({ table: 'products', id: item.id });
                    this.$router.push({ name: 'pluralo.product.edit', params: { id: item.id } });
                }
            },
            addProduct: function() {
                this.$router.push({ name: 'pluralo.product.new' });
            },
            remove: function(item) {
                let vm = this;
                this.removeItem({
                    table: 'products',
                    object: 'product',
                    module: 'inventory',
                    fields: { supplierId: this.account.supplierId, Product: item }
                }).then(function() {
                    vm.flushEvents();
                });
            },
            formatName: function(item) {
                return '<div class="bold">' + item.name + '</div>';
            },
            formatIsActive: function(item) {
                return item.isActive ? 'Active' : '<div class="color-6">Inactive</div>';
            },
            formatCategory: function(item) {
                return (item.categoryList.length > 0) ? item.categoryList.map(i => i.name).join(', ') : '-';
            },
            formatDuration: function(item) {
                return (item.duration !== undefined) ? item.duration : '-';
            },
            formatDurationRange: function(item) {
                if(!item.groups[0]){
                    return ' - '
                }
                let higherHour = item.groups[0].schedules[0].duration
                let lowerHour = item.groups[0].schedules[0].duration

                item.groups.map(group => {
                    group.schedules.map(schedule => {
                        higherHour = (schedule.duration > higherHour)? schedule.duration : higherHour
                        lowerHour = (schedule.duration < lowerHour)? schedule.duration : lowerHour

                    })
                })


                if(higherHour == lowerHour){
                    return moment.duration(higherHour).format("h:mm")
                    // return higherHour
                } else {
                    return moment.duration(lowerHour).format("h:mm") + ' to ' + moment.duration(higherHour).format("h:mm")
                    // return lowerHour + ' to ' + higherHour;
                }
            },
            // formatCapacity: function(item) {
            //     return (item.capacity !== undefined) ? item.capacity : '-';
            // },
            formatActive: function(item) {
                return (item.active) ? 'Yes' : 'No';
            },
            cancel: function(item) {
                alert('Delete ' + item.name);
            },

        },
        components: {
            List,
            Search,
            Export,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// Products.vue?379d2203